import { GetIexNews } from "$gql/queries/general/GetIexNews.gen";
import { getImageReference } from "@tiicker/util/lib/contentful/helpers";
import { PinnedNews } from "@tiicker/util/lib/contentful/types";
import LoadingBlock from "components/Loading/LoadingBlock";
import { Asset, Entry } from "contentful";
import React from "react";
import { useQueryBundle } from "source/hooks";
import styles from "./BrandNewsItems.module.scss";
import NewsItem from "../NewsItem/NewsItem";
import Button from "components/core/Button/Button";

interface Props {
  tickerSymbol: string;
  extractedPinnedNews?: Entry<PinnedNews>[];
  includes: { Asset: Asset[] };
  onViewMore: () => void;
}

const BrandNewsItems = (props: Props) => {
  const newsCount = props.extractedPinnedNews?.length || 0;
  const news = useQueryBundle(GetIexNews, {
    variables: {
      ticker: props.tickerSymbol.toLowerCase(),
      count: newsCount < 4 ? 4 - newsCount : 0,
    },
  });

  if (news.state !== "DONE") {
    return <LoadingBlock />;
  }

  const iexNewsItems = news.data.iex.news || [];

  return iexNewsItems.length !== 0 ||
    (props.extractedPinnedNews && props.extractedPinnedNews.length > 0) ? (
    <div className="container">
      <h2 className={styles.BrandNewsItems__header}>Latest news</h2>
      <div className={styles.BrandNewsItemsContainer}>
        <div className={styles.BrandNewsItems}>
          {props.extractedPinnedNews &&
            props.extractedPinnedNews.map((item, index) => {
              const image = getImageReference(
                item.fields?.thumbnail,
                props.includes
              );

              return (
                <NewsItem
                  key={item.sys.id || `pinned-news-${index}`}
                  title={item.fields.title}
                  date={item.sys.createdAt}
                  image={image?.fields.file.url}
                  url={item.fields.url}
                  isPinned={true}
                />
              );
            })}

          {iexNewsItems.map((item, index) => {
            return (
              <NewsItem
                key={`iex-news-${index}`}
                title={item.headline}
                date={item.datetime}
                image={item.image || undefined}
                badge={item.source}
                url={item.url}
              />
            );
          })}
        </div>
        {iexNewsItems && newsCount + iexNewsItems.length === 4 && (
          <div className={styles.BrandNewsItems__viewMore}>
            <Button type="secondary" onClick={props.onViewMore}>
              View more
            </Button>
          </div>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default BrandNewsItems;
